import React, { useId } from 'react';
import P from '@hero/ui-kit/typography/P';
import useTheme from '@hero/branding/theme';
import { MarkSelect, MarkLabel } from '../../../components/MarkControls';
import type { SegmentTargetKind } from '../../../types';
import { TARGET_KINDS, TARGET_KIND_LABELS } from '../segmentForm';
import * as styles from './style.module.css';

type Props = {
    value: SegmentTargetKind | '';
    onChange: (value: SegmentTargetKind | '') => void;
    disabled?: boolean;
};
const TargetKindSelect: React.FC<Props> = ({ value, onChange, disabled }) => {
    const id = useId();
    const { colors } = useTheme();
    return (
        <div className={styles.field}>
            <MarkLabel htmlFor={id} style={{ margin: 0 }}>
                Audience type
            </MarkLabel>
            <MarkSelect
                id={id}
                value={value}
                onChange={(event) => onChange(event.currentTarget.value as SegmentTargetKind | '')}
                disabled={disabled}
                aria-describedby={`${id}-hint`}
                style={{ width: '100%' }}
            >
                <option value="">Choose an audience type</option>
                {TARGET_KINDS.map((kind) => (
                    <option key={kind} value={kind}>
                        {TARGET_KIND_LABELS[kind]}
                    </option>
                ))}
            </MarkSelect>
            <P
                id={`${id}-hint`}
                noDefaultMargin
                size="small"
                styles={{ color: colors.neutrals.textBeta }}
            >
                {disabled
                    ? 'Audience type is fixed after creation.'
                    : 'Choose the type of records this segment will match.'}
            </P>
        </div>
    );
};
export default TargetKindSelect;
